import InteractiveInventoryItemIcon from "../InteractiveInventoryItemIcon/InteractiveInventoryItemIcon";
import InventoryItemDetailsPanel from "./InventoryItemDetailsPanel";
import InventoryItemTransferContext from "../../../../utils/sys/InventoryItemTransferContext";
import Tooltip from "../../../../common/components/wrappers/Tooltip/Tooltip";

import { useContext, useMemo } from "react";
import {
    InventoryItemContainerProps,
    UIInventoryItemContainerProps,
} from "./InventoryItemContainer";
import {
    executeTransfers,
    validateTransfer,
} from "../../../../utils/sys/InventoryItemTransferUtils";

import "./style/InventoryItemIconSlot_style.css";

type Props = UIInventoryItemContainerProps & {
    className?: string;
    tooltipEnabled?: boolean;
};

export default function InventoryItemIconSlot(props: Props): JSX.Element {
    const { transferTargetItemContainer, setTransferTargetItemContainer } =
        useContext(InventoryItemTransferContext);

    const emptyBGSrc =
        props.emptyBGSrc === undefined ? "back01" : props.emptyBGSrc;

    const tooltipContent = useMemo(() => {
        return <InventoryItemDetailsPanel item={props.item} />;
    }, [props.item?.id, props.item, props.tooltipEnabled]);

    const transferPayload: InventoryItemContainerProps = useMemo(
        () => ({
            id: props.id,
            collectionID: props.collectionID ?? undefined,
            item: props.item,
            itemRestrictor: props.itemRestrictor,
            transferVariables: props.transferVariables,
        }),
        [props.id, props.item, props.itemRestrictor]
    );

    return (
        <Tooltip
            tooltipContent={tooltipContent}
            enabled={props.tooltipEnabled && props.item != null}
            direction="auto-left-right"
            offsetX={20}
        >
            <InteractiveInventoryItemIcon
                className={`inventory-item-icon-slot-container${
                    props.className == null ? `` : ` ${props.className}`
                }`}
                bgSrc={props.item == null ? emptyBGSrc : props.item.bgSrc}
                bgColor={props.item == null ? null : props.item.bgColor}
                iconSrc={
                    props.item == null ? props.emptyIconSrc : props.item.iconSrc
                }
                iconColor={props.item == null ? null : props.item.iconColor}
                onClick={(event) => {
                    if (props.onClick == null) {
                        if (props.isEditable) {
                            if (transferTargetItemContainer == null) {
                                setTransferTargetItemContainer(transferPayload);
                            } else {
                                if (
                                    transferTargetItemContainer.id === props.id
                                ) {
                                    setTransferTargetItemContainer(null);
                                } else if (
                                    validateTransfer(
                                        transferPayload,
                                        transferTargetItemContainer
                                    )
                                ) {
                                    executeTransfers({
                                        transfers: [
                                            {
                                                item: transferTargetItemContainer.item,
                                                setItemCallback:
                                                    transferPayload
                                                        .transferVariables
                                                        ?.setItemCallback,
                                            },
                                            {
                                                item: transferPayload.item,
                                                setItemCallback:
                                                    transferTargetItemContainer
                                                        .transferVariables
                                                        ?.setItemCallback,
                                            },
                                        ],
                                        onComplete: () => {
                                            props.transferVariables?.onTransferSequenceComplete?.();

                                            if (
                                                transferTargetItemContainer
                                                    .transferVariables
                                                    ?.onTransferSequenceComplete !=
                                                    null &&
                                                transferTargetItemContainer
                                                    .transferVariables
                                                    ?.onTransferSequenceComplete !==
                                                    props.transferVariables
                                                        ?.onTransferSequenceComplete
                                            ) {
                                                transferTargetItemContainer.transferVariables.onTransferSequenceComplete();
                                            }
                                        },
                                    });

                                    setTransferTargetItemContainer(null);
                                }
                            }
                        }
                    } else {
                        props.onClick({
                            event,
                            target: transferPayload,
                        });
                    }

                    event?.stopPropagation();
                }}
                onLongClick={
                    props.isEditable === true ? props.onLongClick : undefined
                }
                highlightColor={
                    props.isSelected
                        ? "active"
                        : props.isValidTarget
                        ? "valid"
                        : null
                }
            />
        </Tooltip>
    );
}
